module.exports = __webpack_public_path__ + "static/blume-mobile-373ebd60071677df0cc3ef3dbe87b1c3.jpg";